export const inBrowser = typeof window !== 'undefined';

function isBeekeeperIOSWindow(window: any) {
    const iosWindow = window;
    return iosWindow.webkit !== undefined && iosWindow.webkit.messageHandlers.beekeeper !== undefined;
}

function isBeekeeperAndroidWindow(window: any) {
    const androidWindow = window;
    return (
        androidWindow.BeekeeperBridge !== undefined &&
        typeof androidWindow.BeekeeperBridge.get === 'function' &&
        !androidWindow.BeekeeperBridge.isWebBridge
    );
}

export function isBeekeeperIos(): boolean {
    return inBrowser && isBeekeeperIOSWindow(window);
}

export function isBeekeeperAndroid(): boolean {
    return inBrowser && isBeekeeperAndroidWindow(window);
}

export function isBeekeeperMobile(): boolean {
    return isBeekeeperIos() || isBeekeeperAndroid();
}

export type MobileOS = 'Android' | 'iOS' | 'webOS' | 'Opera Mini';

export const detectMobileOS = (): MobileOS | undefined => {
    const { userAgent } = navigator;

    if (/android/i.test(userAgent) || isBeekeeperAndroid()) {
        return 'Android';
    }

    if (/iPad|iPhone|iPod/.test(userAgent) || isBeekeeperIos()) {
        return 'iOS';
    }

    if (/webOS/.test(userAgent)) {
        return 'webOS';
    }

    if (/Opera Mini/.test(userAgent)) {
        return 'Opera Mini';
    }

    return undefined;
};

export const detectMobileAppWebView = (): boolean => {
    if (isBeekeeperMobile()) {
        return true;
    }

    const { userAgent } = navigator;

    return /LumApps-WebInMobile\/([\w.]+)(?:-debug)?\((\d+)\) (\w+)\/([A-z0-9.]+)(?:\((\d+)\))?/.test(userAgent);
};

export const detectLumAppsMobileAppVersion = (): string | null => {
    const { userAgent } = navigator;

    const regex = /LumApps-WebInMobile\/([\w.]+)(?:-debug)?\((\d+)\) (\w+)\/([A-z0-9.]+)/;
    const match = userAgent.match(regex);

    if (!match || isBeekeeperMobile()) {
        return null;
    }

    return match[1];
};

export const isLumAppsMinMobileAppVersion = (version: number): boolean => {
    const appVersionStr = detectLumAppsMobileAppVersion();
    if (!appVersionStr) {
        return false;
    }

    const appVersion = parseInt(appVersionStr.split('.')[0], 10);
    return !Number.isNaN(appVersion) && appVersion >= version;
};
